import { Decimal } from 'decimal.js';

export const multiplicar_decimal = (valor, multiplicador) => {
  const decimal_str = new Decimal(valor).mul(multiplicador).toString();
  const resultado = parseInt(decimal_str, 10);
  return resultado;
};
